import styled from 'styled-components';

interface IScScrollTopButton {
	isVisible: boolean;
}

export const ScScrollTopIcon = styled.div<IScScrollTopButton>`
	position: fixed;
	bottom: 125px;
	right: ${({ isVisible }) => (isVisible ? '0px' : '-60px')};
	width: 40px;
	height: 40px;
	background: ${({ theme }) => theme.colors.scrollTopIcon};
	border-radius: 5px 0 0 5px;
	padding: 0;
	box-sizing: border-box;
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.2s linear;
	svg {
		width: 15px;
		height: 15px;
	}
	path {
		fill: ${({ theme }) => theme.colors.white};
	}
`;
